import React, { useMemo } from 'react';
import type { User } from '../types';

type UserTableRowProps = {
  hidden?: boolean;
  isSelected: boolean;
  officeName: string;
  user: User;
  onUserSelection: (userId: number, isSelected: boolean) => void;
};

const UserTableRow = ({ hidden, isSelected, officeName, user, onUserSelection } : UserTableRowProps) => {
  const inputId = useMemo(() => `permissions_other_user_ids_${user.id}`, [user.id]);
  return (
    <tr className="align-middle" hidden={hidden} key={user.id}>
      <td>
        <label className="fw-semibold clickable d-flex gap-2 align-items-center" htmlFor={inputId}>
          <span>
            <input
              checked={isSelected}
              id={inputId}
              name="user[permissions_other_user_ids][]"
              type="checkbox"
              value={user.id}
              onChange={e => onUserSelection(user.id, e.target.checked)}
            />
          </span>
          <span>
            {user.firstName} {user.lastName}
          </span>
        </label>
      </td>
      <td>
        <label className="fw-semibold clickable" htmlFor={inputId}>
          {officeName}
        </label>
      </td>
    </tr>
  );
};

export default UserTableRow;
